import React from 'react';
import { Display } from '@/components/Display/Display';
import LinkGuide from '../LinkGuide';
import preImg from '@/assets/images/mobile/pre_icon.webp';
import errImg from '@/assets/images/usual/errImg.webp';
import s from './index.module.scss';

// PreQuestion 组件
const PreQuestion = ({
    type = 'agent',
    currentAgent = {},
    submitMsg,
    pre_question_json = [],
    clickGuide,
    showGuide,
    guideData = [],
    disabled = false
}) => {
    // 处理图片加载失败
    const handleImageError = (e) => {
        if (e.target.src !== errImg) {
            e.target.src = errImg;
        }
    };

    return (
        <div className={s['chats-top']}>
            <Display show={type === 'agent'}>
                <div className={s['no-content']}>
                    <div className={s['introduce']}>{currentAgent?.introduction || `Hi~，我是${currentAgent.name}`}</div>
                </div>
            </Display>
            <Display show={type === 'skill'}>
                <div className={s['no-content']}>
                    <div className={s['introduce']}>{currentAgent?.introduction || `${currentAgent.name}`}</div>
                </div>
            </Display>
            <Display show={showGuide}>
                <LinkGuide onClick={clickGuide} data={guideData}></LinkGuide>
            </Display>

            <Display show={pre_question_json && pre_question_json.length}>
                <div className={s['preset-question-wrap']}>
                    <div className={s['preset-question-title']}>
                        <img src={preImg} alt="" onError={handleImageError} /> 试试这样问我
                    </div>
                    <div className={s['preset-question-list']}>
                        {pre_question_json &&
                            pre_question_json.map((ele, index) => {
                                return (
                                    <div
                                        onClick={() => {
                                            if (disabled) {
                                                return;
                                            }
                                            submitMsg(ele);
                                        }}
                                        key={index}
                                        className={`${s['preset-question-item']} ${disabled ? s['disabled'] : ''}`}
                                    >
                                        {ele}
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </Display>
        </div>
    );
};

export default PreQuestion;
